import { showBlurCards } from './showBlurCards';
import { isGateTestBypass } from './gateTestBypass';

/**
 * @memberof module:util
 * @function
 * @name shouldGateResults
 * @description Whether to render BlurCards (the email+captcha unlock) instead
 * of real rate cards. True for:
 * <br> (a) the legacy marketing/quote-link flow, driven by the server's
 * `show_blur_cards` flag on the rate JSON, OR
 * <br> (b) ANY public visitor — i.e. NOT arriving via the portal iframe (no
 * `user`+`verification` URL params) — per the public rate-gate feature.
 * Without (b), public organic searches never trigger the gate, because the
 * server flag defaults false outside the legacy flow.
 * <br> Both require `enableSearchBlurCards` (true once a search has
 * completed; the unlock thunk flips it back false to reveal real cards).
 *
 * @param {Object} seaFCLJSON
 * @param {Object} seaLCLJSON
 * @param {Object} airJSON
 * @param {Object} initAuth - `{ user, verification }` from the iframe URL
 * @param {boolean} enableSearchBlurCards
 * @returns {boolean}
 *
 * @example
 * shouldGateResults({}, {}, {}, {}, true); //true (public visitor, no iframe auth)
 * shouldGateResults({}, {}, {}, { user: 'a', verification: 'b' }, true); //false (portal iframe)
 * shouldGateResults({}, {}, {}, {}, false); //false (no search completed yet)
 */
export const shouldGateResults = (
  seaFCLJSON,
  seaLCLJSON,
  airJSON,
  initAuth,
  enableSearchBlurCards
) => {
  if (!enableSearchBlurCards) return false;
  if (isGateTestBypass()) return false; // dev/test switch — non-prod hosts only

  const { user, verification } = initAuth || {};
  const isPortalIframeUser = !!(user && verification);
  const legacyBlurCards = showBlurCards(seaFCLJSON, seaLCLJSON, airJSON);

  return legacyBlurCards || !isPortalIframeUser;
};
